import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const token = params.get("token");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white p-8 rounded-xl border">
        <h2 className="text-2xl font-bold text-slate-900">Set new password</h2>
        <div>
          <Label>New password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
        </div>
        <Button type="submit" className="w-full">Reset password</Button>
        <div className="text-center"><Link to="/login" className="text-sm text-blue-600 hover:underline">Back to sign in</Link></div>
      </form>
    </div>
  );
}
